import { useState, useEffect } from 'react';
import {
  withLoading,
  createDateObject,
  useTranslator,
  MarkdownRenderer,
  withRouter,
  useAppContext,
  callNativeAppRemoveLastRoute,
  withMobileAppMode,
  cloudflareImage,
  callNativeMobileApp,
} from '@front-activerse/common-components';
import { Navigate, useLocation } from 'react-router-dom';
import { Container, Button, Row, Col } from 'reactstrap';
import Layout from '../../Layout/Layout';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import TitleBar from '../../Layout/TitleBar';

const Article = ({ article, accessTo, loadSaleProduct, loadContent, mobileAppMode, router }) => {
  const { t } = useTranslator();
  const location = useLocation();

  const {
    consts: { APP_BRAND },
    svgInline: { DownArrow },
  } = useAppContext();

  const [fromArticleList, setFromArticleList] = useState(false);

  useEffect(() => {
    if (article) {
      router.context.trackFirebaseEvent('screen_view', {
        firebase_screen: 'Feed_ID',
        feed_ID: article.id,
      });
    }

    if (router.location.state?.fromArticleList) {
      setFromArticleList(true);
    } else {
      setFromArticleList(false);
    }
  }, []);

  useEffect(() => {
    const iframe = document.querySelector('iframe');
    const layout = document.getElementById('layout');

    if (iframe) {
      layout?.addEventListener('scroll', handleScroll);

      return () => {
        layout?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [location.pathname]);

  const handleScroll = () => {
    const layout = document.getElementById('layout');
    if (layout.scrollTop !== 0) {
      callNativeMobileApp({
        action: 'pull_to_refresh',
        payload: {
          isOnTop: false,
        },
      });
    }
  };

  const renderLead = () => {
    if (article.lead.markdown !== '') {
      return (
        <div className="article-lead">
          <MarkdownRenderer
            content={article.lead.markdown}
            loadSaleProduct={loadSaleProduct}
            downArrow={DownArrow}
          />
        </div>
      );
    }

    return '';
  };

  const renderImage = () => {
    if (article.photoUrl) {
      const coverImage = cloudflareImage(article.photoUrl, `${APP_BRAND}`, 'articleFull');
      return (
        <div className="article-img">
          <img src={coverImage} className="img-fluid" alt="" />
        </div>
      );
    }
    return null;
  };

  const renderContent = (hasAccess) => {
    if (article.content.markdown !== '') {
      return (
        <div className="cms-content">
          <MarkdownRenderer
            content={article.content.markdown}
            loadSaleProduct={loadSaleProduct}
            loadContent={loadContent}
            hasAccess={hasAccess}
            articleId={article.id}
            downArrow={DownArrow}
          />
          <div className="clearfix" />
        </div>
      );
    }

    return '';
  };

  const renderSummary = () => {
    if (article.summary.markdown !== '') {
      return (
        <>
          <div className="article-summary">
            <MarkdownRenderer
              content={article.summary.markdown}
              loadSaleProduct={loadSaleProduct}
              downArrow={DownArrow}
            />
          </div>
          <hr />
        </>
      );
    }
    return '';
  };

  let hasAccess = false;
  if (accessTo) {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const date = createDateObject(accessTo);
    if (date >= today) {
      hasAccess = true;
    }
  }

  if (article) {
    return (
      <Layout>
        <TitleBar level={1}>{t('articleDetails.navbarTitle')}</TitleBar>

        <div className="page-template-knowledge">
          <Container className="py-md-4">
            <Row>
              <Col xl={{ size: 10, offset: 1 }}>
                <div className="page-container">
                  <div className="article-container">
                    <span
                      className="category"
                      style={{
                        color: `#${article.category.label.color}`,
                        backgroundColor: `#${article.category.label.bgColor}`,
                      }}
                    >
                      {article.category.name}
                    </span>
                    <h1 className="article-title title-large semi-bold mb-xl">{article.title}</h1>
                    {renderLead()}
                    {renderImage()}
                    {renderContent(hasAccess)}
                    {renderSummary()}

                    {!mobileAppMode && (
                      <>
                        <hr />
                        <div className="text-center">
                          <Button
                            color="secondary"
                            className="w-100 w-md-auto"
                            onClick={() => {
                              router.context.trackFirebaseEvent('user_action', {
                                action: 'tap-back_to_feed',
                                location: 'V_Feed_ID',
                                feed_ID: article.id,
                              });
                              if (fromArticleList) {
                                router.navigate(-1);
                                callNativeAppRemoveLastRoute();
                              } else {
                                router.navigate('/knowledge');
                              }
                            }}
                            outline
                          >
                            {fromArticleList
                              ? t('feed.backToAllArticles.button')
                              : t('feed.otherArticles.button')}
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Layout>
    );
  }
  return <Navigate to="/error" replace={true} />;
};

const Placeholder = () => <UniversalPlaceholder titleBar="articleDetails.navbarTitle" />;

export default withMobileAppMode(withLoading(withRouter(Article), Placeholder));
